import React, { Component } from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import { connect } from 'react-redux';

class Footer extends Component{

    render() {
        const currentYear = new Date().getFullYear();
    return(
      <footer className="home-page-footer">
        <div className="footer-start-row">
                <p className="centered-subtext-xs">Copyright {currentYear}, Commercial Fire, LLC. All Rights Reserved.</p>
        </div>
        <div className="footer-end-row">
          <a href="/" className="footer-link">Privacy Policy</a>
          <a href="/" className="footer-link">Contact Us</a>
        </div>
      </footer>
    );
  }
}


const mapStateToProps = function(state) {
  return {
    user: state.oidc.user
  }
};

//export default Footer;
export default withRouter(connect(mapStateToProps)(Footer));